//Styles
import Styles from "./styles.module.scss";
import { useQuery } from "hooks/query";
import localTermsOfUse from "../../documents/terms_of_use.pdf";

const TermsOfUse = () => {
  const { data, loading } = useQuery({
    url: "/api/legal/documents/current/",
  });
  const document = data?.find((doc) => doc.document_type === "terms_of_use");
  // Fall back to the bundled PDF when the API fails or has no current document
  const source = document?.file || (loading ? null : localTermsOfUse);

  return (
    <section className={Styles.wrapper}>
      <h3 style={{ marginBlock: "20px" }}>Terms of Use</h3>
      {source && (
        <iframe
          title="terms"
          src={`${source}#toolbar=0&navpanes=0`}
          height={"100%"}
          width={"100%"}
        />
      )}
    </section>
  );
};

export default TermsOfUse;
